import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { resetSearchError } from '@commerce-search-webcomponents/sdk';
import { OverlayProps } from './types/propTypes';
import styles from './Overlay.module.scss';

const Overlay = ({ children, fadeOut, onBackdropClick }: OverlayProps) => {
  const dispatch = useDispatch();

  useEffect(
    () => () => {
      dispatch(resetSearchError('typeaheadSearchError'));
    },
    [],
  );

  return (
    <>
      <div className={`${styles['overlay-container']} ${fadeOut ? styles['fade-out'] : ''}`}>{children}</div>
      <div className={styles['overlay-backdrop']} onClick={() => onBackdropClick?.()} aria-hidden="true"></div>
    </>
  );
};

export default Overlay;
